/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// -----------------------------------------------------------------------------
// IMPORTS
// -----------------------------------------------------------------------------

// External/Third party dependenices
import React from 'react';
import PropTypes from 'prop-types';

// Internal dependencies
import { ThemeContext } from '@rakuten/contexts/ThemeContext';
import { View } from '@rakuten/modules-core-components';


// -----------------------------------------------------------------------------
// SPACER COMPONENT
// -----------------------------------------------------------------------------

class Spacer extends React.Component {

  static contextType = ThemeContext

  // Set prop type validation
  static propTypes = {
    // Height of the spacer element [optional]
    height: PropTypes.number,

    //Width of the spacer element [optional]
    width: PropTypes.number
  }

  // Set default prop values
  static defaultProps = {
    height: 0,
    width: 0
  }

  constructor(props) {
    super(props);
  }

  // ---------------------------------------------------------------------------
  // LIFECYCLE
  // ---------------------------------------------------------------------------

  render() {
    let { width, height } = this.props;

    const dimensions = {
      height: `${height}rem`,
      minHeight: `${height}rem`,
      minWidth: `${width}rem`,
      width: `${width}rem`
    };

    return (
      <View style={dimensions} />
    );
  }

}


// -----------------------------------------------------------------------------
// EXPORTS
// -----------------------------------------------------------------------------

export default Spacer;
